<template>
  <div class="user-guide-page">
    <div class="world-map-bg"></div>
    <v-container>
      <div class="page-header text-center mb-10">
        <p class="subtitle">{{ $t('userguide.subtitle') }}</p>

      </div>

      <v-row>
        <v-col cols="12">
          <div class="stats-banner mb-8">
            <v-row>
              <v-col cols="6" md="3">
                <div class="stat-item">
                  <div class="stat-number">80+</div>
                  <div class="stat-label">{{ $t('userguide.stats.countries') }}</div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="stat-item">
                  <div class="stat-number">1000+</div>
                  <div class="stat-label">{{ $t('userguide.stats.clients') }}</div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="stat-item">
                  <div class="stat-number">25+</div>
                  <div class="stat-label">{{ $t('userguide.stats.years') }}</div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="stat-item">
                  <div class="stat-number">100%</div>
                  <div class="stat-label">{{ $t('userguide.stats.satisfaction') }}</div>
                </div>
              </v-col>
            </v-row>
          </div>

          <v-card class="mb-12 guide-card" elevation="3" rounded="lg">
            <v-card-title class="card-title pa-4">
              <v-icon size="large" color="primary" class="me-3">mdi-handshake</v-icon>
              {{ $t('userguide.partnership.title') }}
            </v-card-title>
            <v-card-text>
              <div class="guide-content">
                <v-row>
                  <v-col cols="12" md="6" class="guide-section">
                    <v-card class="section-card" variant="outlined" rounded="lg">
                      <v-card-item>
                        <v-card-title class="d-flex align-center">
                          <v-icon color="primary" class="me-2">mdi-account-group</v-icon>
                          <span class="section-number">01</span>
                          <span class="section-title ms-2">{{ $t('userguide.partnership.section1.title') }}</span>
                        </v-card-title>
                        <v-card-text>
                          <p class="section-text">{{ $t('userguide.partnership.section1.text') }}</p>
                        </v-card-text>
                      </v-card-item>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" class="guide-section">
                    <v-card class="section-card" variant="outlined" rounded="lg">
                      <v-card-item>
                        <v-card-title class="d-flex align-center">
                          <v-icon color="primary" class="me-2">mdi-account-hard-hat</v-icon>
                          <span class="section-number">02</span>
                          <span class="section-title ms-2">{{ $t('userguide.partnership.section2.title') }}</span>
                        </v-card-title>
                        <v-card-text>
                          <p class="section-text">{{ $t('userguide.partnership.section2.text') }}</p>
                          <p class="section-text-small">{{ $t('userguide.partnership.section2.original') }}</p>
                        </v-card-text>
                      </v-card-item>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" class="guide-section">
                    <v-card class="section-card" variant="outlined" rounded="lg">
                      <v-card-item>
                        <v-card-title class="d-flex align-center">
                          <v-icon color="primary" class="me-2">mdi-shield-check</v-icon>
                          <span class="section-number">03</span>
                          <span class="section-title ms-2">{{ $t('userguide.partnership.section3.title') }}</span>
                        </v-card-title>
                        <v-card-text>
                          <p class="section-text">{{ $t('userguide.partnership.section3.text') }}</p>
                          <p class="section-text-small">{{ $t('userguide.partnership.section3.original') }}</p>
                        </v-card-text>
                      </v-card-item>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" class="guide-section">
                    <v-card class="section-card" variant="outlined" rounded="lg">
                      <v-card-item>
                        <v-card-title class="d-flex align-center">
                          <v-icon color="primary" class="me-2">mdi-bullhorn</v-icon>
                          <span class="section-number">04</span>
                          <span class="section-title ms-2">{{ $t('userguide.partnership.section4.title') }}</span>
                        </v-card-title>
                        <v-card-text>
                          <p class="section-text">{{ $t('userguide.partnership.section4.text') }}</p>
                          <p class="section-text-small">{{ $t('userguide.partnership.section4.original') }}</p>
                        </v-card-text>
                      </v-card-item>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="mb-12 guide-card" elevation="3" rounded="lg">
            <v-card-title class="card-title pa-4">
              <v-icon size="large" color="primary" class="me-3">mdi-cog</v-icon>
              {{ $t('userguide.service.title') }}
            </v-card-title>
            <v-card-text>
              <div class="guide-content">
                <div class="service-steps">
                  <div class="service-step">
                    <div class="step-header">
                      <div class="step-number">01</div>
                      <h3 class="step-title">{{ $t('userguide.service.step1.title') }}</h3>
                    </div>
                    <div class="step-content">
                      <p class="section-text">{{ $t('userguide.service.step1.text') }}</p>
                    </div>
                  </div>

                  <div class="service-step">
                    <div class="step-header">
                      <div class="step-number">02</div>
                      <h3 class="step-title">{{ $t('userguide.service.step2.title') }}</h3>
                    </div>
                    <div class="step-content">
                      <p class="section-text">{{ $t('userguide.service.step2.text') }}</p>
                      <p class="section-text-small">{{ $t('userguide.service.step2.original') }}</p>
                    </div>
                  </div>

                  <div class="service-step">
                    <div class="step-header">
                      <div class="step-number">03</div>
                      <h3 class="step-title">{{ $t('userguide.service.step3.title') }}</h3>
                    </div>
                    <div class="step-content">
                      <p class="section-text">{{ $t('userguide.service.step3.text') }}</p>
                    </div>
                  </div>

                  <div class="service-step">
                    <div class="step-header">
                      <div class="step-number">04</div>
                      <h3 class="step-title">{{ $t('userguide.service.step4.title') }}</h3>
                    </div>
                    <div class="step-content">
                      <p class="section-text">{{ $t('userguide.service.step4.text') }}</p>
                    </div>
                  </div>

                  <div class="service-step">
                    <div class="step-header">
                      <div class="step-number">05</div>
                      <h3 class="step-title">{{ $t('userguide.service.step5.title') }}</h3>
                    </div>
                    <div class="step-content">
                      <p class="section-text">{{ $t('userguide.service.step5.text') }}</p>
                    </div>
                  </div>
                </div>

                <div class="certification-section mb-8">
                  <h3 class="text-center mb-6">{{ $t('userguide.certifications.title') }}</h3>
                  <div class="d-flex flex-wrap justify-center gap-4">
                    <div class="cert-badge">
                      <img src="/img/certifications/iso.svg" alt="ISO 9001" class="cert-icon">
                      <span>ISO 9001</span>
                    </div>
                    <div class="cert-badge">
                      <img src="/img/certifications/ce.svg" alt="CE" class="cert-icon">
                      <span>CE</span>
                    </div>
                    <div class="cert-badge">
                      <img src="/img/certifications/sgs.svg" alt="SGS" class="cert-icon">
                      <span>SGS</span>
                    </div>
                    <div class="cert-badge">
                      <img src="/img/certifications/tuv.svg" alt="TÜV" class="cert-icon">
                      <span>TÜV</span>
                    </div>
                    <div class="cert-badge">
                      <img src="/img/certifications/asme.svg" alt="ASME" class="cert-icon">
                      <span>ASME</span>
                    </div>
                  </div>
                </div>

                <v-card class="warranty-card mt-8" color="primary" rounded="lg">
                  <v-card-title class="text-white">
                    <v-icon color="white" class="me-2">mdi-shield-check</v-icon>
                    {{ $t('userguide.warranty.title') }}
                  </v-card-title>
                  <v-card-text class="text-white">
                    <h3 class="mb-2">{{ $t('userguide.warranty.question') }}</h3>
                    <p class="answer-text">{{ $t('userguide.warranty.answer') }}</p>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <div class="global-footer">
      <div class="footer-top py-10">
        <v-container>
          <div class="text-center">
            <h2 class="footer-heading mb-6">{{ $t('userguide.footer.cta') }}</h2>
            <v-btn color="primary" size="x-large" class="contact-btn" rounded="pill" elevation="3">
              <v-icon start size="large">mdi-email</v-icon>
              {{ $t('userguide.footer.contact_btn') }}
            </v-btn>
          </div>
        </v-container>
      </div>

      <div class="footer-bottom py-8">
        <v-container>
          <div class="payment-methods">
            <h3 class="payment-title mb-5">{{ $t('userguide.footer.payment_title') }}</h3>
            <div class="payment-divider mb-5"></div>
            <div class="payment-icons">
              <div class="payment-category">
                <h4 class="category-title">{{ $t('userguide.footer.credit_cards') }}</h4>
                <div class="d-flex justify-center gap-4">
                  <div class="payment-item">
                    <img src="/img/payment/visa.svg" alt="Visa" class="payment-icon">
                    <span class="payment-name">Visa</span>
                  </div>
                  <div class="payment-item">
                    <img src="/img/payment/mastercard.svg" alt="Mastercard" class="payment-icon">
                    <span class="payment-name">Mastercard</span>
                  </div>
                </div>
              </div>

              <div class="payment-category">
                <h4 class="category-title">{{ $t('userguide.footer.international') }}</h4>
                <div class="d-flex justify-center gap-4">
                  <div class="payment-item">
                    <img src="/img/payment/paypal.svg" alt="PayPal" class="payment-icon">
                    <span class="payment-name">PayPal</span>
                  </div>
                  <div class="payment-item">
                    <img src="/img/payment/western-union.svg" alt="Western Union" class="payment-icon">
                    <span class="payment-name">Western Union</span>
                  </div>
                </div>
              </div>

              <div class="payment-category">
                <h4 class="category-title">{{ $t('userguide.footer.asian_markets') }}</h4>
                <div class="d-flex justify-center gap-4">
                  <div class="payment-item">
                    <img src="/img/payment/alipay.svg" alt="Alipay" class="payment-icon">
                    <span class="payment-name">Alipay</span>
                  </div>
                  <div class="payment-item">
                    <img src="/img/payment/wechat-pay.svg" alt="WeChat Pay" class="payment-icon">
                    <span class="payment-name">WeChat Pay</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';

const {locale} = useI18n();
const currentLocale = ref(locale.value);

// Watch for changes in the locale toggle and update the app locale
watch(currentLocale, (newLocale) => {
  locale.value = newLocale;
  // Store user's language preference
  localStorage.setItem('userLanguage', newLocale);
});

onMounted(() => {
  // Set initial locale from localStorage if available
  const savedLocale = localStorage.getItem('userLanguage');
  if (savedLocale && (savedLocale === 'en' || savedLocale === 'zh')) {
    currentLocale.value = savedLocale;
    locale.value = savedLocale;
  }

  // Add scroll animation for cards
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {threshold: 0.1});

  // Observe all cards and steps
  document.querySelectorAll('.section-card, .step-content, .warranty-card').forEach(element => {
    observer.observe(element);
  });
});
</script>

<style scoped>
.user-guide-page {
  background-color: #f9f9f9;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.world-map-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background-image: url('/img/world-map-dots.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  opacity: 0.05;
  z-index: 0;
  pointer-events: none;
}

.page-header {
  padding-top: 2rem;
  animation: fadeIn 1s ease;
  position: relative;
  z-index: 1;
}

.global-badge {
  display: inline-flex;
  align-items: center;
  background-color: rgb(var(--v-theme-primary));
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-weight: 500;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.globe-icon {
  margin-right: 0.5rem;
  animation: rotate 10s linear infinite;
}

.language-flags {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.flag-icon {
  width: 30px;
  height: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  cursor: pointer;
}

.flag-icon:hover {
  transform: translateY(-5px);
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.page-title {
  color: rgb(var(--v-theme-primary));
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.subtitle {
  font-size: 1.2rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 300;
  margin-top: 1rem;
}

.language-selector {
  display: inline-flex;
  justify-content: center;
  margin: 0 auto;
}

.divider-primary {
  border-color: rgb(var(--v-theme-primary));
  border-width: 3px;
  opacity: 0.7;
}

.guide-content {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.stats-banner {
  background: linear-gradient(135deg, rgb(var(--v-theme-primary)), rgba(var(--v-theme-primary), 0.7));
  border-radius: 12px;
  padding: 2rem 1rem;
  color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.stat-item {
  padding: 1rem;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.stat-label {
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.guide-card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s;
}

.guide-card:hover {
  transform: translateY(-5px);
}

.card-title {
  background-color: rgba(var(--v-theme-primary), 0.05);
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.section-card {
  height: 100%;
  transition: all 0.3s;
  border: 1px solid rgba(var(--v-theme-primary), 0.1);
  position: relative;
  overflow: hidden;
}

.section-card:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: rgba(var(--v-theme-primary), 0.3);
}

.section-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 50px 50px 0;
  border-color: transparent rgba(var(--v-theme-primary), 0.1) transparent transparent;
  transition: all 0.3s;
}

.section-card:hover::before {
  border-color: transparent rgba(var(--v-theme-primary), 0.2) transparent transparent;
}

.section-number {
  background-color: rgb(var(--v-theme-primary));
  color: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
}

.section-title {
  color: rgb(var(--v-theme-primary));
  font-weight: 600;
  font-size: 1.15rem;
  line-height: 1.4;
}

.section-text {
  color: rgba(0, 0, 0, 0.8);
  line-height: 1.7;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.section-text-small {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.85rem;
  line-height: 1.5;
  font-style: italic;
}

.service-steps {
  position: relative;
  padding-left: 10px;
}

.service-steps::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 20px;
  width: 2px;
  background: linear-gradient(to bottom, rgba(var(--v-theme-primary), 0.7), rgba(var(--v-theme-primary), 0.1));
}

.service-step {
  position: relative;
  margin-bottom: 2rem;
  padding-left: 3rem;
}

.step-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.step-number {
  background-color: rgb(var(--v-theme-primary));
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1rem;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  position: absolute;
  left: -10px;
  z-index: 2;
}

.step-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: rgb(var(--v-theme-primary));
  margin-left: 1rem;
}

.step-content {
  background-color: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  border-left: 3px solid rgb(var(--v-theme-primary));
}

.service-step:hover .step-content {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transform: translateX(5px);
}

.warranty-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s;
}

.warranty-card:hover {
  box-shadow: 0 8px 20px rgba(var(--v-theme-primary), 0.3);
}

.answer-text {
  font-size: 1.1rem;
  line-height: 1.6;
  font-weight: 500;
}

.certification-section {
  padding: 2rem;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.cert-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 8px;
  min-width: 100px;
  transition: all 0.3s;
}

.cert-badge:hover {
  background-color: rgba(var(--v-theme-primary), 0.1);
  transform: translateY(-5px);
}

.cert-badge span {
  margin-top: 0.5rem;
  font-weight: 600;
}

.cert-icon {
  width: 50px;
  height: 50px;
  transition: transform 0.3s;
}

.cert-badge:hover .cert-icon {
  transform: scale(1.1);
}

.global-footer {
  position: relative;
  z-index: 1;
  margin-top: 3rem;
}

.footer-top {
  background: linear-gradient(135deg, rgb(var(--v-theme-primary)), rgba(var(--v-theme-primary), 0.8));
  color: white;
  position: relative;
  overflow: hidden;
}

.footer-top::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('/img/world-map-dots.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  opacity: 0.1;
  z-index: 0;
}

.footer-heading {
  font-size: 2rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
}

.contact-btn {
  padding: 0.75rem 2rem !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  background-color: white !important;
  color: rgb(var(--v-theme-primary)) !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  transition: all 0.3s;
}

.contact-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.footer-bottom {
  background-color: #f8f8f8;
  border-top: 1px solid #eaeaea;
}

.payment-methods {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.payment-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #333;
}

.payment-divider {
  width: 80px;
  height: 3px;
  background-color: rgb(var(--v-theme-primary));
  margin: 0 auto;
}

.payment-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
}

.payment-category {
  margin-bottom: 1.5rem;
}

.category-title {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 1rem;
  font-weight: 500;
}

.payment-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.payment-icon {
  height: 40px;
  width: 70px;
  object-fit: contain;
  filter: grayscale(0.3);
  transition: all 0.3s;
  padding: 5px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.payment-name {
  font-size: 0.85rem;
  color: #666;
}

.payment-item:hover .payment-icon {
  filter: grayscale(0);
  transform: translateY(-5px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-card.visible, .step-content.visible, .warranty-card.visible {
  opacity: 1;
  transform: translateY(0);
}

.section-card, .step-content, .warranty-card {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 26px !important;
  }

  .section-title {
    font-size: 1rem;
  }

  .step-title {
    font-size: 1rem;
  }

  .card-title {
    font-size: 1.2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .service-steps {
    padding-left: 5px;
  }

  .service-steps::before {
    left: 15px;
  }

  .service-step {
    padding-left: 2.5rem;
  }

  .step-number {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
    left: -5px;
  }

  .step-content {
    padding: 1rem;
  }

  .footer-heading {
    font-size: 1.5rem;
  }

  .contact-btn {
    padding: 0.5rem 1.5rem !important;
    font-size: 1rem !important;
  }

  .payment-title {
    font-size: 1.3rem;
  }

  .payment-icons {
    flex-direction: column;
    gap: 1.5rem;
  }

  .payment-category {
    width: 100%;
  }

  .payment-icon {
    height: 35px;
    width: 60px;
  }
}
</style>
